/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';

import { Fade } from 'react-awesome-reveal';

import Button from '../elements/Button';
import { ORG_TAGLINE } from '../constants';

// Hero is text-centric (no phone mockups). Decorative gradient blobs and
// staggered Fade reveals carry the visual weight while we run on placeholder
// imagery — see plan section "Hero image" decision.
export default function Hero() {
  return (
    <section className="hero relative overflow-hidden min-h-[80vh] flex items-center justify-center">
      {/* Animated background gradient blobs */}
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div
          className="absolute top-1/4 -left-20 w-96 h-96 bg-theme-purple/20
            rounded-full blur-3xl animate-blob"
        />
        <div
          className="absolute top-1/3 right-0 w-80 h-80 bg-theme-gold/30
            rounded-full blur-3xl animate-blob animation-delay-2000"
        />
        <div
          className="absolute bottom-0 left-1/3 w-72 h-72 bg-light-theme-purple
            rounded-full blur-3xl animate-blob animation-delay-4000"
        />
      </div>

      <div className="w-full max-w-4xl mx-auto px-5 py-16 lg:py-24 text-center">
        {/* Trust badge */}
        <Fade direction="down" triggerOnce>
          <div
            className="inline-flex items-center gap-2 px-4 py-2
              bg-theme-purple/10 rounded-full mb-8 backdrop-blur-sm"
          >
            <span className="relative flex h-3 w-3">
              <span
                className="animate-ping absolute inline-flex h-full w-full
                  rounded-full bg-theme-gold opacity-75"
              />
              <span
                className="relative inline-flex rounded-full h-3 w-3 bg-theme-gold"
              />
            </span>
            <span className="text-sm font-medium text-theme-purple">
              Cleveland · Mt. Pleasant Neighborhood
            </span>
          </div>
        </Fade>

        {/* Headline with gradient sweep */}
        <Fade direction="up" cascade damping={0.15} triggerOnce>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-theme-blue font-serif font-bold leading-[1.1] mb-6">
            <span className="block">Where Cleveland Youth</span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-theme-purple via-theme-gold to-theme-purple bg-[length:200%_auto] animate-gradient">
              Find Their Balance
            </span>
          </h1>
        </Fade>

        <Fade direction="up" delay={300} triggerOnce>
          <p className="font-light text-lg md:text-xl text-gray-500 leading-relaxed mb-10 max-w-2xl mx-auto">
            {ORG_TAGLINE}
            {' '}
            We empower young people through artistic instruction, mentorship, and
            personal development — helping them redefine their future and break
            unfavorable generational cycles.
          </p>
        </Fade>

        {/* CTAs */}
        <Fade direction="up" delay={500} triggerOnce>
          <div className="flex flex-wrap gap-4 justify-center mb-12">
            <Button
              href="/programs"
              type="link"
              className="group flex items-center px-8 py-4 text-white text-lg font-medium bg-gradient-to-r from-theme-purple to-dark-theme-purple rounded-xl shadow-lg hover:shadow-2xl hover:shadow-theme-purple/25 transform hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              View Programs
              <svg
                className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Button>
            <Button
              href="/donate"
              type="link"
              className="flex items-center px-8 py-4 text-theme-blue text-lg font-medium bg-theme-gold rounded-xl hover:bg-theme-gold-dark transform hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              Donate
            </Button>
            <Button
              href="/get-involved"
              type="link"
              className="flex items-center px-8 py-4 text-theme-purple text-lg font-medium bg-white/80 backdrop-blur-sm border-2 border-theme-purple rounded-xl hover:bg-theme-purple hover:text-white transform hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              Get Involved
            </Button>
          </div>
        </Fade>

        {/* Snapshot stats — replace with verifiable numbers as collected */}
        <Fade direction="up" delay={700} triggerOnce>
          <div className="flex flex-wrap gap-10 justify-center text-center">
            <div className="group cursor-default">
              <p className="text-3xl font-serif font-bold text-theme-blue group-hover:text-theme-purple transition-colors">
                2023
              </p>
              <p className="text-sm text-gray-500">Founded in Cleveland</p>
            </div>
            <div className="group cursor-default">
              <p className="text-3xl font-serif font-bold text-theme-blue group-hover:text-theme-purple transition-colors">
                3
              </p>
              <p className="text-sm text-gray-500">Pillars of programming</p>
            </div>
            <div className="group cursor-default">
              <p className="text-3xl font-serif font-bold text-theme-blue group-hover:text-theme-purple transition-colors">
                Mt. Pleasant
              </p>
              <p className="text-sm text-gray-500">Neighborhood served</p>
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
}
